import { Box } from '@mui/material';
import { FC, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

const PageCardContent: FC<Props> = ({ children }) => {
  return (
    <Box mt={6} width="94%" maxWidth={400}>
      {children}
    </Box>
  );
};

export default PageCardContent;
